<component :is="layout"></component>